import { Navigate, useLocation } from "react-router-dom";
import { useSSO } from "../context/SSO";
import Loader from "../components/Feedback/Loader";

const PublicRoute = ({ children }) => {
  const location = useLocation();
  const auth = useSSO();

  const getRedirectPath = () => {
    const roles = auth?.user?.user?.roles || [];
    const hasMasterRole = roles.some(role => role.name === "MASTER");
    const hasAdminCompanyRole = roles.some(role => role.name === "RESPONSAVEL");

    if (hasMasterRole || (hasMasterRole && hasAdminCompanyRole)) {
      return "/registration";
    } else if (hasAdminCompanyRole) {
      return "/survey-analysis";
    }

    return "/login";
  };

  if (auth?.isAuthLoading || auth.isUserLoading) {
    return <Loader />;
  }

  if (auth.authenticated && auth?.user?.user) {
    const redirectPath = getRedirectPath();
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  if (location.pathname === "/") {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default PublicRoute;